var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 51,
    viewBox: "0 0 105 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9735 8.54579C56.2686 5.51478 59.4593 5.5 59.4593 5.5C59.4593 5.5 59.9339 8.34966 57.6539 11.0948C55.2194 14.026 52.4522 13.5464 52.4522 13.5464C52.4522 13.5464 51.9326 11.2411 53.9735 8.54579ZM52.7441 15.5425C53.9248 15.5425 56.1161 13.9163 58.9684 13.9163C63.8782 13.9163 65.8096 17.4169 65.8096 17.4169C65.8096 17.4169 62.032 19.3522 62.032 24.0481C62.032 29.3454 66.7379 31.1711 66.7379 31.1711C66.7379 31.1711 63.4483 40.4486 59.005 40.4486C56.9642 40.4486 55.3776 39.0706 53.2273 39.0706C51.036 39.0706 48.8614 40.5 47.4451 40.5C43.3877 40.5001 38.2617 31.6994 38.2617 24.6251C38.2617 17.665 42.6005 14.0138 46.6701 14.0138C49.3157 14.0138 51.3687 15.5425 52.7441 15.5425Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppleLogo);
export default __webpack_public_path__ + "static/media/icon-apple-logo.e0428e6eeb3ffa02f9c9c8bb7a13acf6.svg";
export { ForwardRef as ReactComponent };